module.exports = __webpack_public_path__ + "img/ArticulatedLift.d300ca62.png";